var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50586 15.992L8.02986 9.02899C8.48986 8.06199 9.19186 7.26299 9.99686 9.17999C10.7399 10.95 11.8469 14.19 12.5019 15.995M6.65186 13.002H11.3209",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.464 4.318C2 5.636 2 7.758 2 12C2 16.242 2 18.364 3.464 19.682C4.93 21 7.286 21 12 21C16.714 21 19.071 21 20.535 19.682C21.999 18.364 22 16.242 22 12C22 7.758 22 5.636 20.535 4.318C19.072 3 16.714 3 12 3C7.286 3 4.929 3 3.464 4.318Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4839 8.98706V11.9821M18.4839 11.9821V15.9251M18.4839 11.9821H16.4659C16.2259 11.9821 15.9879 12.0261 15.7639 12.1131C14.0709 12.7701 14.0709 15.2131 15.7639 15.8701C15.9889 15.9571 16.2259 16.0011 16.4659 16.0011H18.4839",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.955487bcd75057dfe0ae60a8fe2ac9cc.svg";
export { ForwardRef as ReactComponent };